import LocalAtmIcon from "@mui/icons-material/LocalAtmRounded";
import { Box, Tooltip, Typography } from "@mui/material";
import WholesaleSlider from "components/wholesaleSlider";
import { useContainer, useTemplate } from "containers/templateDetail/store";
import maxBy from "lodash/maxBy";
import dynamic from "next/dynamic";
import * as React from "react";

const BigOrderInquire = dynamic(
  () => import("components/notionForm/bigOrderInquire")
);

export default function PriceCalculator({
  setDiscount,
  quantity,
  setQuantity,
}): React.ReactElement {
  const { id: templateID, wholesale_group } = useTemplate();
  const [open, setOpen] = useContainer.isBigOrderInquireModelOpen();
  const [activeShippingRate] = useContainer.activeShippingRate();
  const [isLoadBigOrderInquire, setLoadBigOrderInquire] = React.useState(false);

  const maxQuantity = React.useMemo(() => {
    return maxBy(wholesale_group.wholesale_price, function (o: any) {
      return o.quantity;
    }).quantity;
  }, [wholesale_group]);

  const onChange = (discount, value) => {
    setDiscount(discount === null ? 1 : (100 - discount) / 100);
    setQuantity(value === 0 ? 1 : value);
  };

  const handleClick = () => {
    setLoadBigOrderInquire(true);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{}}>
      <Box
        component="button"
        // onClick={() => setBulkPriceClacShow(!isBulkPriceClacShow)}
        sx={{
          py: 2,
          px: 2,
          bgcolor: "grey.300",
          width: "100%",
          border: "0px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <Tooltip
            arrow
            title="🎉 You can get discount if you are ordering bulk items, add other related products to shopping cart, the quantity and discount will also be calculated together"
            placement="top"
          >
            <Typography
              variant="body2"
              sx={{
                display: "flex",
                alignItem: "center",
                fontWeight: (theme) => theme.typography.fontWeightSemiBold,
              }}
            >
              <LocalAtmIcon />
              &nbsp; Bulk price calculator
            </Typography>
          </Tooltip>
          <Typography
            variant="body2"
            sx={{
              position: "relative",
              ml: "auto",
              textDecoration: "underline",
            }}
          >
            {quantity}
            {quantity === maxQuantity ? "+" : ""} items
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", px: 3, py: 2 }}>
        <Box sx={{ flex: 1 }}>
          <WholesaleSlider
            wholesalePrice={wholesale_group.wholesale_price}
            initValue={maxQuantity}
            onChange={onChange}
            minQauntity={activeShippingRate?.min_order_quantity || 1}
          />
        </Box>
      </Box>
      <Box sx={{ px: 2, pb: 2 }}>
        <Box>
          <Typography variant="body2" display="inline">
            Large orders offer better discounts,
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ textDecoration: "underline", ml: 1, cursor: "pointer" }}
            color="primary"
            onClick={handleClick}
            display="inline"
          >
            click here for more
          </Typography>
        </Box>
      </Box>
      {isLoadBigOrderInquire && (
        <BigOrderInquire
          templateID={templateID}
          open={open}
          handleClose={handleClose}
        />
      )}
    </Box>
  );
}
